import React, {useCallback, useEffect, useState} from "react";
import {useEventListener} from "../../../infrastructure/hooks/useEventListener";
import {KEY_CODES} from "../../../core/consts";
import {NEW_SEARCH_WIDGET} from "../new-search-widget.consts";
import {observer} from "mobx-react";

export const NewSearchWidgetSportKeyboardClickComposer = (Widget) => observer(({controller, onClick}) => {
  const {state, device, config} = controller;
  const {isSmallView} = device;
  const {source} = config;
  const {sportsList, hasQuery, isSportTypeMenuOpen, isSportTypesDropdownActiveNavigation} = state;
  const isDropdownOpen: Boolean = hasQuery && isSportTypeMenuOpen;

  const [highlightedItemIndex, setHighlightedItemIndex] = useState(null);

  useEffect(() => {
    if (isDropdownOpen) {
      controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onTabClick, {index: NEW_SEARCH_WIDGET.TAB_SECTION.sportsDropdown})
    }

    isDropdownOpen ? setHighlightedItemIndex(null) : setHighlightedItemIndex(0)
  }, [isDropdownOpen])

  const onKeyboardClick = useCallback((event) => {
    if (!isSmallView) {
      if (isSportTypesDropdownActiveNavigation) {
        const {keyCode} = event;
        const {space, down, up, enter} = KEY_CODES;

        if (keyCode === space) {
          event.preventDefault()

          isSportTypeMenuOpen ? setHighlightedItemIndex(null) : setHighlightedItemIndex(0)
          controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onSportTypeMenuClick, {isOpen: !isSportTypeMenuOpen})
        }

        if (isSportTypeMenuOpen && [down, up, escape].includes(keyCode)) {
          const sportTypesLength: Number = sportsList.length;

          if (keyCode === down) {
            event.preventDefault()

            const nextItem: Number = highlightedItemIndex === null ? 0 : (highlightedItemIndex + 1).mod(sportTypesLength);
            setHighlightedItemIndex(nextItem);
          } else if (keyCode === up) {
            event.preventDefault()

            const previewItem: Number = highlightedItemIndex === null ? sportTypesLength - 1 : (highlightedItemIndex - 1).mod(sportTypesLength);
            setHighlightedItemIndex(previewItem);
          }
        }

        if (isSportTypeMenuOpen && keyCode === enter && highlightedItemIndex !== null) {
          event.preventDefault()

          const sportItemId: Number = sportsList[highlightedItemIndex].id;
          controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onSportTypeClick, {id: sportItemId, source})
          controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onTabClick, {reset: true});
          onClick?.()
        }
      }
    }
  });

  useEventListener('keydown', onKeyboardClick);

  const newProps = {
    controller,
    isDropdownOpen,
    sportsList,
    highlightedItemIndex,
    setHighlightedItemIndex
  };

  return <Widget {...newProps}/>;
});
